// Minimal polyfills for libraries that expect Node globals in the browser.
// CRA4 used to shim these; some third-party bundles (loaded via <script>) may still expect them.

/* eslint-disable no-undef */
if (typeof window !== 'undefined') {
	if (!window.process) {
		window.process = { env: {} };
	} else if (!window.process.env) {
		window.process.env = {};
	}
}

